module.exports = __webpack_public_path__ + "img/expro1.439a1d3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/tpl/expro1.png
// module id = 6Nvb
// module chunks = 57